"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9773],{

/***/ 6372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11 5V16.17L6.11997 11.29C5.72997 10.9 5.08997 10.9 4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7L11.29 19.29C11.68 19.68 12.31 19.68 12.7 19.29L19.29 12.7C19.68 12.31 19.68 11.68 19.29 11.29C18.9 10.9 18.27 10.9 17.88 11.29L13 16.17V5C13 4.45 12.55 4 12 4C11.45 4 11 4.45 11 5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 16274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 19V7.83001L17.88 12.71C18.27 13.1 18.91 13.1 19.3 12.71C19.69 12.32 19.69 11.69 19.3 11.3L12.71 4.71001C12.32 4.32001 11.69 4.32001 11.3 4.71001L4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7C5.08997 13.09 5.71997 13.09 6.10997 12.7L11 7.83001V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 72234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CommitButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96293);
/* harmony import */ var hooks_useSwitchNetworkLoading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30822);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91131);
/* harmony import */ var hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62349);
/* harmony import */ var _NetworkModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21581);
/* harmony import */ var _Trans__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96464);










var wrongNetworkProps = {
    variant: "danger",
    disabled: false,
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Trans__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: "Wrong Network"
    })
};
var CommitButton = function(props) {
    var isWrongNetwork = (0,hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_2__/* .useActiveChainId */ .gi)().isWrongNetwork;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,hooks_useSwitchNetworkLoading__WEBPACK_IMPORTED_MODULE_1__/* .useSwitchNetworkLoading */ .c)(), 1), switchNetworkLoading = ref[0];
    var setHideWrongNetwork = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useSetAtom */ .b9)(_NetworkModal__WEBPACK_IMPORTED_MODULE_3__/* .hideWrongNetworkModalAtom */ .v);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        onClick: function(e) {
            if (isWrongNetwork) {
                setHideWrongNetwork(false);
            } else {
                var ref;
                (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
            }
        }
    }), switchNetworkLoading && {
        disabled: true
    }, isWrongNetwork && wrongNetworkProps));
};


/***/ }),

/***/ 19527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencyInputPanel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(6260);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(95963);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(51071);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx + 12 modules
var CurrencySearchModal = __webpack_require__(51011);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(74314);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/NumericalInput.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: 16px;\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-8de12016-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: "decimal",
        title: t("Token Amount"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});
/* harmony default export */ var NumericalInput = ((/* unused pure expression or super */ null && (Input)));

// EXTERNAL MODULE: ./src/components/CopyButton/index.tsx
var CopyButton = __webpack_require__(57370);
// EXTERNAL MODULE: ./src/components/AddToWallet/AddToWalletButton.tsx
var AddToWalletButton = __webpack_require__(49234);
;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/index.tsx



function CurrencyInputPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: ",
        ";\n"
    ]);
    CurrencyInputPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 8px;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: ",
        " 8px 0px 0px;\n      height: auto;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0.5rem;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.75rem 1rem 0 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-radius: 0px 16px 16px 16px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  opacity: 0.6;\n  background-color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}















var InputRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a26db1c-0"
})(CurrencyInputPanel_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "0.75rem 0.5rem 0.75rem 1rem" : "0.75rem 0.75rem 0.75rem 1rem";
});
var CurrencySelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "text",
    scale: "sm"
}).withConfig({
    componentId: "sc-4a26db1c-1"
})(_templateObject2(), function(param) {
    var zapStyle = param.zapStyle, theme = param.theme;
    return zapStyle && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.colors.background, theme.colors.cardBorder, zapStyle === "zap" ? "0px" : "8px");
});
var LabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a26db1c-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a26db1c-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a26db1c-4"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme, error = param.error;
    return theme.shadows[error ? "warning" : "inset"];
}, function(param) {
    var zapStyle = param.zapStyle;
    return !!zapStyle && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a26db1c-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, onMax = param.onMax, showMaxButton = param.showMaxButton, label = param.label, onCurrencySelect = param.onCurrencySelect, currency = param.currency, _disableCurrencySelect = param.disableCurrencySelect, disableCurrencySelect = _disableCurrencySelect === void 0 ? false : _disableCurrencySelect, _hideBalance = param.hideBalance, hideBalance = _hideBalance === void 0 ? false : _hideBalance, zapStyle = param.zapStyle, beforeButton = param.beforeButton, _pair = param.pair, pair = _pair === void 0 ? null : _pair, otherCurrency = param.otherCurrency, id = param.id, showCommonBases = param.showCommonBases, commonBasesType = param.commonBasesType, disabled = param.disabled, error = param.error, showBUSD = param.showBUSD;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var selectedCurrencyBalance = (0,hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, currency !== null && currency !== void 0 ? currency : undefined);
    var t = (0,src/* useTranslation */.$G)().t;
    var token = pair ? pair.liquidityToken : (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency : null;
    var tokenAddress = token ? (0,utils/* isAddress */.UJ)(token.address) : null;
    var amountInDollar = (0,useBUSDPrice/* useBUSDCurrencyAmount */.vB)(showBUSD ? currency : undefined, Number.isFinite(+value) ? +value : undefined);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal/* default */.Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: currency,
        otherSelectedCurrency: otherCurrency,
        showCommonBases: showCommonBases,
        commonBasesType: commonBasesType
    })), 1), onPresentCurrencyModal = ref[0];
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            beforeButton,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelectButton, {
                                zapStyle: zapStyle,
                                className: "open-currency-select-button",
                                selected: !!currency,
                                onClick: function() {
                                    if (!disableCurrencySelect) {
                                        onPresentCurrencyModal();
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                            currency0: pair.token0,
                                            currency1: pair.token1,
                                            size: 16,
                                            margin: true
                                        }) : currency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currency,
                                            size: "24px",
                                            style: {
                                                marginRight: "8px"
                                            }
                                        }) : null,
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: [
                                                pair === null || pair === void 0 ? void 0 : pair.token0.symbol,
                                                ":",
                                                pair === null || pair === void 0 ? void 0 : pair.token1.symbol
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: (currency && currency.symbol && currency.symbol.length > 20 ? "".concat(currency.symbol.slice(0, 4), "...").concat(currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)) : currency === null || currency === void 0 ? void 0 : currency.symbol) || t("Select a currency")
                                        }),
                                        !disableCurrencySelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
                                    ]
                                })
                            }),
                            token && tokenAddress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    gap: "4px"
                                },
                                ml: "4px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                        width: "16px",
                                        buttonColor: "textSubtle",
                                        text: tokenAddress,
                                        tooltipMessage: t("Token address copied"),
                                        tooltipTop: -20,
                                        tooltipRight: 40,
                                        tooltipFontSize: 12
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWalletButton/* default */.Z, {
                                        variant: "text",
                                        p: "0",
                                        height: "auto",
                                        width: "fit-content",
                                        tokenAddress: tokenAddress,
                                        tokenSymbol: token.symbol,
                                        tokenDecimals: token.decimals,
                                        tokenLogo: (0,_instanceof/* default */.Z)(token, tokens_src/* WrappedTokenInfo */.DT) ? token.logoURI : undefined
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        onClick: !disabled && onMax,
                        color: "textSubtle",
                        fontSize: "14px",
                        style: {
                            display: "inline",
                            cursor: "pointer"
                        },
                        children: !hideBalance && !!currency ? t("Balance: %balance%", {
                            balance: (ref1 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref1 !== void 0 ? ref1 : t("Loading")
                        }) : " -"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputPanel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        as: "label",
                        zapStyle: zapStyle,
                        error: error,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                selected: disableCurrencySelect,
                                children: [
                                    !!currency && showBUSD && Number.isFinite(amountInDollar) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        mr: "12px",
                                        children: [
                                            "~",
                                            (0,formatBalance/* formatNumber */.uf)(amountInDollar),
                                            " USD"
                                        ]
                                    }),
                                    account && currency && !disabled && showMaxButton && label !== "To" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: onMax,
                                        scale: "xs",
                                        variant: "secondary",
                                        style: {
                                            textTransform: "uppercase"
                                        },
                                        children: t("Max")
                                    })
                                ]
                            })
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 41228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ht": function() { return /* binding */ TransactionErrorContent; },
/* harmony export */   "pM": function() { return /* binding */ ConfirmationModalContent; },
/* harmony export */   "rD": function() { return /* binding */ TransactionSubmittedContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16274);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44700);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95963);
/* harmony import */ var components_Loader_CircleLoader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7010);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64011);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53854);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51071);
/* harmony import */ var _Layout_Column__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41914);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93293);
/* harmony import */ var _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49234);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6895e12d-0"
})(_templateObject());
var Section = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_8__/* .AutoColumn */ .Tz).withConfig({
    componentId: "sc-6895e12d-1"
})(_templateObject1());
var ConfirmedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_8__/* .ColumnCenter */ .lg).withConfig({
    componentId: "sc-6895e12d-2"
})(_templateObject2());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Loader_CircleLoader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: "64px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_8__/* .AutoColumn */ .Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Column__WEBPACK_IMPORTED_MODULE_8__/* .AutoColumn */ .Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
function TransactionSubmittedContent(param) {
    var onDismiss = param.onDismiss, chainId = param.chainId, hash = param.hash, currencyToAdd = param.currencyToAdd;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var token = (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_6__/* .wrappedCurrency */ .pu)(currencyToAdd, chainId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        strokeWidth: 0.5,
                        width: "90px",
                        color: "primary"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_8__/* .AutoColumn */ .Tz, {
                    gap: "12px",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            fontSize: "20px",
                            children: t("Transaction Submitted")
                        }),
                        chainId && hash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            external: true,
                            small: true,
                            href: (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .getBlockExploreLink */ .C)(hash, "transaction", chainId),
                            children: t("View on %site%", {
                                site: (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .getBlockExploreName */ .X0)(chainId)
                            })
                        }),
                        currencyToAdd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "tertiary",
                            mt: "12px",
                            width: "fit-content",
                            marginTextBetweenLogo: "6px",
                            textOptions: _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_10__/* .AddToWalletTextOptions.TEXT_WITH_ASSET */ .L.TEXT_WITH_ASSET,
                            tokenAddress: token.address,
                            tokenSymbol: currencyToAdd.symbol,
                            tokenDecimals: token.decimals,
                            tokenLogo: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(token, _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_7__/* .WrappedTokenInfo */ .DT) ? token.logoURI : undefined
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            onClick: onDismiss,
                            mt: "20px",
                            children: t("Close")
                        })
                    ]
                })
            ]
        })
    });
}
function ConfirmationModalContent(param) {
    var bottomContent = param.bottomContent, topContent = param.topContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: topContent()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: bottomContent()
            })
        ]
    });
}
function TransactionErrorContent(param) {
    var message = param.message, onDismiss = param.onDismiss;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_8__/* .AutoColumn */ .Tz, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        color: "failure",
                        width: "64px"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        color: "failure",
                        style: {
                            textAlign: "center",
                            width: "85%",
                            wordBreak: "break-word"
                        },
                        children: message
                    })
                ]
            }),
            onDismiss ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                justifyContent: "center",
                pt: "24px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    onClick: onDismiss,
                    children: t("Dismiss")
                })
            }) : null
        ]
    });
}
var TransactionConfirmationModal = function(_param) {
    var title = _param.title, onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, attemptingTxn = _param.attemptingTxn, hash = _param.hash, pendingText = _param.pendingText, content = _param.content, currencyToAdd = _param.currencyToAdd, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
        "title",
        "onDismiss",
        "customOnDismiss",
        "attemptingTxn",
        "hash",
        "pendingText",
        "content",
        "currencyToAdd"
    ]);
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().chainId;
    var handleDismiss = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
        title: title,
        headerBackground: "gradients.cardHeader"
    }, props), {
        onDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmationPendingContent, {
            pendingText: pendingText
        }) : hash ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransactionSubmittedContent, {
            chainId: chainId,
            hash: hash,
            onDismiss: handleDismiss,
            currencyToAdd: currencyToAdd
        }) : content()
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (TransactionConfirmationModal);


/***/ }),

/***/ 75865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UK": function() { return /* binding */ ApprovalState; },
  "qL": function() { return /* binding */ useApproveCallback; },
  "re": function() { return /* binding */ useApproveCallbackFromTrade; }
});

// UNUSED EXPORTS: useApproveCallbackFromInputCurrencyAmount

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(95963);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts
var swap_sdk_src = __webpack_require__(13372);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 9 modules
var useContract = __webpack_require__(16583);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useERC20 */.X_)(token === null || token === void 0 ? void 0 : token.address);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,hooks/* useSingleCallResult */.Wk)({
        contract: spender && owner ? contract : null,
        functionName: "allowance",
        args: inputs
    }).result;
    return (0,react.useMemo)(function() {
        return token && typeof allowance !== "undefined" ? swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/dist/index.js
var limit_orders_lib_dist = __webpack_require__(55855);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var hooks_useActiveWeb3React = __webpack_require__(64011);
;// CONCATENATED MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts





var useGelatoLimitOrdersLib_useGelatoLimitOrdersLib = function() {
    var chainId = useActiveWeb3React().chainId;
    var providerOrSigner = null;
    return useMemo(function() {
        if (!chainId || !providerOrSigner) {
            console.error("Could not instantiate GelatoLimitOrders: missing chainId or library");
            return undefined;
        }
        if (chainId !== ChainId.BSC) return undefined;
        try {
            return new GelatoLimitOrders(chainId, providerOrSigner, GELATO_HANDLER, false);
        } catch (error) {
            console.error("Could not instantiate GelatoLimitOrders: ".concat(error.message));
            return undefined;
        }
    }, [
        chainId,
        providerOrSigner
    ]);
};
/* harmony default export */ var limitOrders_useGelatoLimitOrdersLib = ((/* unused pure expression or super */ null && (useGelatoLimitOrdersLib_useGelatoLimitOrdersLib)));

;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts
















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
var MaxUint256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        addToTransaction: true
    };
    var ref;
    var _addToTransaction = options.addToTransaction, addToTransaction = _addToTransaction === void 0 ? true : _addToTransaction, targetAmount = options.targetAmount;
    var ref1 = (0,dist/* useAccount */.mA)(), account = ref1.address;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* default */.Z)().toastError;
    var token = (amountToApprove === null || amountToApprove === void 0 ? void 0 : (ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isToken) ? amountToApprove.currency : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    var pendingApproval = (0,transactions_hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        var ref;
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if ((ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isNative) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var tokenContract = (0,useContract/* useERC20 */.X_)(token === null || token === void 0 ? void 0 : token.address);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var approve = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var useExact, estimatedGas, ref, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(approvalState !== ApprovalState.NOT_APPROVED)) {
                        _ctx.next = 4;
                        break;
                    }
                    toastError(t("Error"), t("Approve was called unnecessarily"));
                    console.error("approve was called unnecessarily");
                    return _ctx.abrupt("return", undefined);
                case 4:
                    if (!token) {
                        // toastError(t('Error'), t('No token'))
                        console.error("no token");
                    // return undefined
                    }
                    if (tokenContract) {
                        _ctx.next = 9;
                        break;
                    }
                    toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                        tokenAddress: token === null || token === void 0 ? void 0 : token.address
                    }));
                    console.error("tokenContract is null");
                    return _ctx.abrupt("return", undefined);
                case 9:
                    if (amountToApprove) {
                        _ctx.next = 13;
                        break;
                    }
                    toastError(t("Error"), t("Missing amount to approve"));
                    console.error("missing amount to approve");
                    return _ctx.abrupt("return", undefined);
                case 13:
                    if (spender) {
                        _ctx.next = 17;
                        break;
                    }
                    toastError(t("Error"), t("No spender"));
                    console.error("no spender");
                    return _ctx.abrupt("return", undefined);
                case 17:
                    useExact = false;
                    _ctx.next = 20;
                    return tokenContract.estimateGas.approve([
                        spender,
                        MaxUint256
                    ], {
                        account: tokenContract.account
                    }).catch(function() {
                        // general fallback for tokens who restrict approval amounts
                        useExact = true;
                        var ref, ref1;
                        return tokenContract.estimateGas// @ts-ignore
                        .approve([
                            spender,
                            (ref1 = (ref = amountToApprove === null || amountToApprove === void 0 ? void 0 : amountToApprove.quotient) !== null && ref !== void 0 ? ref : targetAmount) !== null && ref1 !== void 0 ? ref1 : MaxUint256
                        ], {
                            account: tokenContract.account
                        }).catch(function(e) {
                            console.error("estimate gas failure", e);
                            toastError(t("Error"), t("Unexpected error. Could not estimate gas for the approve."));
                            return null;
                        });
                    });
                case 20:
                    estimatedGas = _ctx.sent;
                    if (estimatedGas) {
                        _ctx.next = 23;
                        break;
                    }
                    return _ctx.abrupt("return", undefined);
                case 23:
                    ;
                    return _ctx.abrupt("return", callWithGasPrice(tokenContract, "approve", [
                        spender,
                        useExact ? (ref1 = (ref = amountToApprove === null || amountToApprove === void 0 ? void 0 : amountToApprove.quotient) !== null && ref !== void 0 ? ref : targetAmount) !== null && ref1 !== void 0 ? ref1 : MaxUint256 : MaxUint256
                    ], {
                        gas: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                    }).then(function(response) {
                        if (addToTransaction) {
                            addTransaction(response, {
                                summary: "Approve ".concat(amountToApprove.currency.symbol),
                                translatableSummary: {
                                    text: "Approve %symbol%",
                                    data: {
                                        symbol: amountToApprove.currency.symbol
                                    }
                                },
                                approval: {
                                    tokenAddress: token.address,
                                    spender: spender
                                },
                                type: "approve"
                            });
                        }
                        return response;
                    }).catch(function(error) {
                        (0,sentry/* logError */.H)(error);
                        console.error("Failed to approve token", error);
                        if (!(0,sentry/* isUserRejected */.Z)(error)) {
                            toastError(t("Error"), error.message);
                        }
                        throw error;
                    }));
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        approvalState,
        token,
        tokenContract,
        amountToApprove,
        spender,
        callWithGasPrice,
        targetAmount,
        toastError,
        t,
        addToTransaction,
        addTransaction, 
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    return useApproveCallback(amountToApprove, exchange/* ROUTER_ADDRESS */.bR[chainId]);
}
// Wraps useApproveCallback in the context of a Gelato Limit Orders
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var gelatoLibrary = useGelatoLimitOrdersLib();
    var _address;
    return useApproveCallback(currencyAmountIn, (_address = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _address !== void 0 ? _address : undefined);
}


/***/ }),

/***/ 57164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCatchTxError; },
  "n": function() { return /* binding */ parseError; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(95963);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/errors/base.js
var base = __webpack_require__(69977);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/errors/rpc.js
var rpc = __webpack_require__(42455);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/config/chains.ts
var chains = __webpack_require__(38512);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/clients/createPublicClient.js + 41 modules
var createPublicClient = __webpack_require__(6146);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/clients/transports/http.js
var http = __webpack_require__(27436);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 7 modules
var chunk_LAFZBYO7 = __webpack_require__(40032);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(62349);
;// CONCATENATED MODULE: ./src/hooks/usePublicNodeWaitForTransaction.ts










var viemClientsPublicNodes = chains/* CHAINS.reduce */.zG.reduce(function(prev, cur) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, cur.id, (0,createPublicClient/* createPublicClient */.v)({
        chain: cur,
        transport: (0,http/* http */.d)(cur.rpcUrls.public.http[0], {
            timeout: 15000
        }),
        batch: {
            multicall: {
                batchSize: 1024 * 200
            }
        }
    })));
}, {});
function usePublicNodeWaitForTransaction() {
    var chainId = (0,useActiveChainId/* useActiveChainId */.gi)().chainId;
    var waitForTransaction_ = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(opts) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!viemClientsPublicNodes[chainId]) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", viemClientsPublicNodes[chainId].waitForTransactionReceipt(opts));
                    case 2:
                        return _ctx.abrupt("return", (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, opts), {
                            chainId: chainId
                        })));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(opts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chainId
    ]);
    return {
        waitForTransaction: waitForTransaction_
    };
}

;// CONCATENATED MODULE: ./src/hooks/useCatchTxError.tsx
/* provided dependency */ var process = __webpack_require__(34155);











/// only show corrected parsed viem error
function parseError(err) {
    if ((0,_instanceof/* default */.Z)(err, base/* BaseError */.G)) {
        return err;
    }
    if (typeof err === "string") {
        return new rpc/* UnknownRpcError */.ir(new Error(err));
    }
    if ((0,_instanceof/* default */.Z)(err, Error)) {
        return new rpc/* UnknownRpcError */.ir(err);
    }
    return null;
}
// -32000 is insufficient funds for gas * price + value
var isGasEstimationError = function(err) {
    var ref;
    return (err === null || err === void 0 ? void 0 : (ref = err.data) === null || ref === void 0 ? void 0 : ref.code) === -32000;
};
var notPreview = process.env.NEXT_PUBLIC_VERCEL_ENV !== "preview";
function useCatchTxError() {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useToast/* default */.Z)(), toastError = ref.toastError, toastSuccess = ref.toastSuccess;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var waitForTransaction = usePublicNodeWaitForTransaction().waitForTransaction;
    var ref2 = (0,react.useState)(false), txResponseLoading = ref2[0], setTxResponseLoading = ref2[1];
    var handleNormalError = (0,react.useCallback)(function(error) {
        (0,sentry/* logError */.H)(error);
        var err = parseError(error);
        if (err) {
            toastError(t("Error"), t("Transaction failed with error: %reason%", {
                reason: notPreview ? error.shortMessage || error.message : error.message
            }));
        } else {
            toastError(t("Error"), t("Please try again. Confirm the transaction and make sure you are paying enough gas!"));
        }
    }, [
        t,
        toastError
    ]);
    var handleTxError = (0,react.useCallback)(function(error, hash) {
        (0,sentry/* logError */.H)(error);
        var err = parseError(error);
        toastError(t("Failed"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
            txHash: hash,
            children: err ? t("Transaction failed with error: %reason%", {
                reason: notPreview ? err.shortMessage || err.message : err.message
            }) : t("Transaction failed. For detailed error message:")
        }));
    }, [
        t,
        toastError
    ]);
    var fetchWithCatchTxError = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callTx) {
            var tx, hash, receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tx = null;
                        _ctx.prev = 1;
                        setLoading(true);
                        _ctx.next = 5;
                        return callTx();
                    case 5:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _ctx.sent;
                        hash = typeof tx === "string" ? tx : tx.hash;
                        toastSuccess("".concat(t("Transaction Submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: hash
                        }));
                        _ctx.next = 10;
                        return waitForTransaction({
                            hash: hash
                        });
                    case 10:
                        receipt = _ctx.sent;
                        return _ctx.abrupt("return", receipt);
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,sentry/* isUserRejected */.Z)(_ctx.t0)) {
                            if (!tx) {
                                handleNormalError(_ctx.t0);
                            } else {
                                handleTxError(_ctx.t0, typeof tx === "string" ? tx : tx.hash);
                            }
                        }
                    case 17:
                        _ctx.prev = 17;
                        setLoading(false);
                        return _ctx.finish(17);
                    case 20:
                        return _ctx.abrupt("return", null);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14,
                    17,
                    20
                ]
            ]);
        }));
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        toastSuccess,
        t,
        waitForTransaction,
        handleNormalError,
        handleTxError
    ]);
    var fetchTxResponse = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callTx) {
            var tx, hash;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tx = null;
                        _ctx.prev = 1;
                        setTxResponseLoading(true);
                        _ctx.next = 5;
                        return callTx();
                    case 5:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _ctx.sent;
                        hash = typeof tx === "string" ? tx : tx.hash;
                        toastSuccess("".concat(t("Transaction Submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: hash
                        }));
                        return _ctx.abrupt("return", {
                            hash: hash
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,sentry/* isUserRejected */.Z)(_ctx.t0)) {
                            if (!tx) {
                                handleNormalError(_ctx.t0);
                            } else {
                                handleTxError(_ctx.t0, typeof tx === "string" ? tx : tx.hash);
                            }
                        }
                    case 14:
                        _ctx.prev = 14;
                        setTxResponseLoading(false);
                        return _ctx.finish(14);
                    case 17:
                        return _ctx.abrupt("return", null);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        toastSuccess,
        t,
        handleNormalError,
        handleTxError
    ]);
    return {
        fetchWithCatchTxError: fetchWithCatchTxError,
        fetchTxResponse: fetchTxResponse,
        loading: loading,
        txResponseLoading: txResponseLoading
    };
};


/***/ }),

/***/ 3620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTransactionDeadline; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 9 modules
var useContract = __webpack_require__(16583);
;// CONCATENATED MODULE: ./src/hooks/useCurrentBlockTimestamp.ts



// gets the current timestamp from the blockchain
function useCurrentBlockTimestamp() {
    var ref;
    var multicall = (0,useContract/* useMulticallContract */.gq)();
    var result = (ref = (0,hooks/* useSingleCallResult */.Wk)({
        contract: multicall,
        functionName: "getCurrentBlockTimestamp"
    })) === null || ref === void 0 ? void 0 : ref.result;
    return bignumber/* BigNumber.from */.O$.from(result || "0");
};

;// CONCATENATED MODULE: ./src/hooks/useTransactionDeadline.ts



// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function useTransactionDeadline() {
    var ttl = (0,es/* useSelector */.v9)(function(state) {
        return state.user.userDeadline;
    });
    var blockTimestamp = useCurrentBlockTimestamp();
    return (0,react.useMemo)(function() {
        if (blockTimestamp && ttl) return blockTimestamp.add(ttl);
        return undefined;
    }, [
        blockTimestamp,
        ttl
    ]);
};


/***/ }),

/***/ 17226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92876);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42455);



var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var possibleRejectMessage = [
    "Cancelled by User",
    "cancel",
    "Transaction was rejected"
];
var isUserRejected = function(err) {
    // provider user rejected error code
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(err, viem__WEBPACK_IMPORTED_MODULE_1__/* .UserRejectedRequestError */ .ab)) {
        return true;
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(err, viem__WEBPACK_IMPORTED_MODULE_1__/* .UnknownRpcError */ .ir)) {
        // fallback for some wallets that don't follow EIP 1193, trust, safe
        if (possibleRejectMessage.some(function(msg) {
            var ref;
            return (ref = err.details) === null || ref === void 0 ? void 0 : ref.includes(msg);
        })) {
            return true;
        }
    }
    // fallback for raw rpc error code
    if (typeof err === "object") {
        if ("code" in err && (err.code === 4001 || err.code === "ACTION_REJECTED") || "cause" in err && "code" in err.cause && err.cause.code === 4001) {
            return true;
        }
        if ("cause" in err) {
            return isUserRejected(err.cause);
        }
    }
    return false;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(error);
        } else {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ }),

/***/ 42808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ transactionErrorToUserReadableMessage; }
/* harmony export */ });
/* harmony import */ var hooks_useCatchTxError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57164);

/**
 * This is hacking out the revert reason from the ethers provider thrown error however it can.
 * This object seems to be undocumented by ethers.
 * @param error an error from the ethers provider
 * @param t Translation function
 */ function transactionErrorToUserReadableMessage(error, t) {
    var reason;
    var parsedError = (0,hooks_useCatchTxError__WEBPACK_IMPORTED_MODULE_0__/* .parseError */ .n)(error);
    if (parsedError) {
        reason = parsedError.shortMessage || parsedError.message;
    } else {
        while(error){
            var ref, ref1;
            var _reason, ref2, ref3;
            reason = (ref3 = (ref2 = (_reason = error.reason) !== null && _reason !== void 0 ? _reason : (ref = error.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref2 !== void 0 ? ref2 : error.message) !== null && ref3 !== void 0 ? ref3 : reason;
            var _error;
            // eslint-disable-next-line no-param-reassign
            error = (_error = error.error) !== null && _error !== void 0 ? _error : (ref1 = error.data) === null || ref1 === void 0 ? void 0 : ref1.originalError;
        }
    }
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("execution reverted: ")) === 0) reason = reason.substring("execution reverted: ".length);
    switch(reason){
        case "CandyRouter: EXPIRED":
            return t("The transaction could not be sent because the deadline has passed. Please check that your transaction deadline is not too low.");
        case "CandyRouter: INSUFFICIENT_OUTPUT_AMOUNT":
        case "CandyRouter: EXCESSIVE_INPUT_AMOUNT":
        case "CandyRouter: INSUFFICIENT_A_AMOUNT":
        case "CandyRouter: INSUFFICIENT_B_AMOUNT":
            return t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.");
        case "TransferHelper: TRANSFER_FROM_FAILED":
            return t("The input token cannot be transferred. There may be an issue with the input token.");
        case "Pancake: TRANSFER_FAILED":
            return t("The output token cannot be transferred. There may be an issue with the output token.");
        default:
            if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("undefined is not an object")) !== -1) {
                console.error(error, reason);
                return t("An error occurred when trying to execute this operation. You may need to increase your slippage tolerance. If that does not work, there may be an incompatibility with the token you are trading.");
            }
            return t("Unknown error%reason%. Try increasing your slippage tolerance.", {
                reason: reason ? ': "'.concat(reason, '"') : ""
            });
    }
}


/***/ })

}]);